// @flow
import { type Event } from '../analytics/events/config';
import { GTM_COLLECT_ANALYTICS, isFeatureEnabled } from './FeaturesClient';
import apiConfig from '../config';
import 'isomorphic-fetch';

const trackPageView = (path: string) => {
  if (window.ga) {
    window.ga('send', 'pageview', path);
  }
};

const trackEvent = ({ category, action, label }: Event) => {
  if (window.ga) {
    window.ga('send', 'event', category, action, label);
  }
};

const trackPageViewGTM = (path: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pageview',
    page: {
      path,
    },
  });
};

const trackEventGTM = ({ category, action, label }: Event) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'event',
    category,
    action,
    label,
  });
};

const pushAdditionalData = () => {
  window.dataLayer = window.dataLayer || [];

  fetch(apiConfig.urls.gtmData)
    .then((request) => request.json())
    .then((payload) => {
      window.dataLayer.push({
        event: 'wait_for_data',
        data: payload,
      });
    });
};

const shouldTrackWithGTM = isFeatureEnabled(GTM_COLLECT_ANALYTICS);
export default {
  trackPageView: shouldTrackWithGTM ? trackPageViewGTM : trackPageView,
  trackEvent: shouldTrackWithGTM ? trackEventGTM : trackEvent,
  pushAdditionalData,
};
